/**
 *
 * ActionButtons
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import useDialog from 'containers/Dialog/useDialog.js';
import messages from './messages.js';

const SubmitButton = styled(Button)`
  &[disabled] {
    cursor: wait;
  }
`;

function ActionButtons(props) {
  const { onClose, onSubmit, isFinal } = props;
  const [submitted, setSubmitted] = useState(false);
  const { dlgConfirm } = useDialog();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  function goUp() {
    const uplink = pathname.replace(/\/planner.*$/, '');
    navigate(uplink);
  }

  function handleClose() {
    if (!onClose) {
      goUp();
      return;
    }
    dlgConfirm({ message: messages.savePrompt, yesNo: true })
      .then(() => onClose(true))
      .catch(() => onClose(false))
      .finally(goUp);
  }

  async function handleSubmit() {
    if (onSubmit) {
      setSubmitted(true);
      await onSubmit();
      setSubmitted(false);
    }
  }

  const submitMessage = isFinal ? messages.save : messages.next;
  return (
    <div className="d-flex align-items-center justify-content-between">
      <Button type="button" variant="light" disabled={submitted} onClick={handleClose}><FormattedMessage {...messages.close} /></Button>
      <SubmitButton type="submit" variant="primary" disabled={submitted} onClick={handleSubmit}>
        <FormattedMessage {...submitMessage} />
      </SubmitButton>
    </div>
  );
}

ActionButtons.propTypes = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  isFinal: PropTypes.bool,
};

export default ActionButtons;
